export function setNoteForTitle(title: string, hasCommercialComplexes: boolean | undefined): string {
  if (hasCommercialComplexes) {
    return `${title}*`;
  }

  return title;
}
